

function procladDrawerScroller() {
  return document.querySelector('.page-wrapper') || document.documentElement;
}

let procladDrawerOpener = null;

function procladCloseDrawers() {
  const openDrawers = document.querySelectorAll('.proclad-compare-drawer.is-open');
  openDrawers.forEach((d) => {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    d.inert = true;
  });
  procladDrawerScroller().style.overflow = '';
  if (openDrawers.length && procladDrawerOpener?.isConnected) procladDrawerOpener.focus({ preventScroll: true });
  procladDrawerOpener = null;
}

function procladFocusableIn(container) {
  return [...container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter(
    (el) => el.getClientRects().length > 0
  );
}

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-compare-info]');
  if (opener) {
    const drawer = document.querySelector(
      '.proclad-compare-drawer[data-compare-drawer="' + opener.getAttribute('data-compare-info') + '"]'
    );
    if (drawer) {
      procladCloseDrawers();
      procladDrawerOpener = opener;
      drawer.inert = false;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      procladDrawerScroller().style.overflow = 'hidden';
      drawer.querySelector('.proclad-compare-drawer__close')?.focus({ preventScroll: true });
    }
    return;
  }
  if (e.target.closest('[data-drawer-close]')) procladCloseDrawers();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    const panel = document.querySelector('.proclad-compare-drawer.is-open .proclad-compare-drawer__panel');
    if (!panel) return;
    const focusable = procladFocusableIn(panel);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
    return;
  }
  if (e.key !== 'Escape') return;
  procladCloseDrawers();
  document.querySelectorAll('[data-compare-select][open]').forEach((details) => {
    details.removeAttribute('open');
  });
});

function procladSelectCompareColumn(details, index, label) {
  const mobile = details.closest('.proclad-compare__mobile');
  if (!mobile) return;
  const labelEl = details.querySelector('[data-compare-select-label]');
  if (labelEl) labelEl.textContent = label;
  const nameEl = mobile.querySelector('[data-compare-col-name]');
  if (nameEl) nameEl.textContent = label;
  details.querySelectorAll('[data-compare-select-option]').forEach((btn) => {
    btn.setAttribute('aria-pressed', btn.getAttribute('data-compare-select-option') === index ? 'true' : 'false');
  });
  mobile.querySelectorAll('[data-compare-col-index]').forEach((el) => {
    el.hidden = el.getAttribute('data-compare-col-index') !== index;
  });
  details.removeAttribute('open');
}

document.addEventListener('click', (e) => {
  const option = e.target.closest('[data-compare-select-option]');
  if (option) {
    const details = option.closest('[data-compare-select]');
    if (details) {
      procladSelectCompareColumn(details, option.getAttribute('data-compare-select-option'), option.textContent.trim());
    }
    return;
  }
  document.querySelectorAll('[data-compare-select][open]').forEach((details) => {
    if (!details.contains(e.target)) details.removeAttribute('open');
  });
});
